/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Represent a locale configuration.
 *
 * @class Locale
 * @module Models
 */
/* jshint nomen:false */
define(['./languageTypesMapping'], function(languageTypesMapping) {
    'use strict';
    var validServiceTypes = ['routing', 'search', 'traffic', 'maps', 'reverseGeocoder'];

    function isValidServiceType(serviceType) {
        return validServiceTypes.indexOf(serviceType) > -1;
    }

    function Locale(languageCode) {
        if (!languageTypesMapping.hasOwnProperty(languageCode)) {
            console.warn('Incorrect language code passed to Locale constructor. Defaulting to en-GB');
            languageCode = 'en-GB';
        }
        this._languageCode = languageCode;
    }

    /**
     * Returns the label of the locale.
     * @method getLabel
     * @return {String}
     */
    Locale.prototype.getLabel = function() {
        return languageTypesMapping[this._languageCode].label;
    };

    /**
     * Returns the language's code of the locale.
     * @method getLanguageCode
     * @return {String}
     */
    Locale.prototype.getLanguageCode = function() {
        return this._languageCode;
    };

    /**
     * Returns the language's code for the given service type.
     *
     * @method getValueFor
     * @param {"routing"|"search"|"traffic"|"maps"} [serviceType] The service code.
     *  But we aware of these cases:
     *  - If an invalid code is given the language's code for the service "search" will be return.
     *  - If no value is given it will return the same value as the method
     *    {{#crossLink "Locale/getLanguageCode:method"}}{{/crossLink}}.
     * @return {String}
     */
    Locale.prototype.getValueFor = function(serviceType) {
        var value;
        if (!serviceType) {
            return this._languageCode;
        }
        if (!isValidServiceType(serviceType)) {
            console.warn('Unsupported type passed to getValueFor function in Locale.' +
                'Expecting: ' + validServiceTypes.join(', ') + '. Defaulting to search');
            serviceType = 'search';
        }

        // Reverse geocoder supports the same set of languages as search
        if (serviceType === 'reverseGeocoder') {
            serviceType = 'search';
        }

        value = languageTypesMapping[this._languageCode][serviceType].fallback;
        return value !== undefined ? value : this._languageCode;
    };

    return Locale;
});



// WEBPACK FOOTER //
// ./config/language/locale.js